'use strict';

var template            = require('../templates/Profile.ejs');
var RequestChangesModal = require('./RequestChangesModal');
var Address             = require('models/Address');

module.exports = Backbone.View.extend({
    initialize: function() {
        this.showProfile();
    },
    events: {
        'click .js-request-changes': 'actionRequestChanges'
    },

    showProfile: function() {
        return Promise.all([
            app.employee.fetchCompanyLocation(),
            app.employee.fetchPosition(),
            app.employee.fetchAddress(),
            app.employee.fetchBankAccount()
        ]).then(([location]) => {
            if (location) {
                return location.fetchAddress();
            }
            return Promise.resolve();
        }).then(() => {
            this.model = app.employee;
            this.render();
        });
    },

    render: function() {
        this.$el.html(template({
            model:            this.model,
            Address:          Address,
            nameAbbreviation: this.model.has('imageUrl') ?
                '' : this.model.getNameAbbreviation()
        }));

        this.requestChangesModal = new RequestChangesModal();
        this.$el.append(this.requestChangesModal.$el);
    },

    actionRequestChanges: function(event) {
        this.requestChangesModal.render(event);
        this.requestChangesModal.show();
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/Profile.js